/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Body_Assessment_Countdown_RunningInputs */

const en_us2_body_assessment_countdown_running = /** @type {(inputs: Body_Assessment_Countdown_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Photo in ${i?.seconds}`)
};

const pt_br2_body_assessment_countdown_running = /** @type {(inputs: Body_Assessment_Countdown_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A foto sai em ${i?.seconds}`)
};

const es_419_body_assessment_countdown_running = /** @type {(inputs: Body_Assessment_Countdown_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foto en ${i?.seconds}`)
};

const pt_pt2_body_assessment_countdown_running = /** @type {(inputs: Body_Assessment_Countdown_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foto dentro de ${i?.seconds}`)
};

const fr_fr2_body_assessment_countdown_running = /** @type {(inputs: Body_Assessment_Countdown_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Photo dans ${i?.seconds}`)
};

const de_de2_body_assessment_countdown_running = /** @type {(inputs: Body_Assessment_Countdown_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foto in ${i?.seconds}`)
};

const it_it2_body_assessment_countdown_running = /** @type {(inputs: Body_Assessment_Countdown_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foto tra ${i?.seconds}`)
};

/**
* | output |
* | --- |
* | "Photo in {seconds}" |
*
* @param {Body_Assessment_Countdown_RunningInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_countdown_running = /** @type {((inputs: Body_Assessment_Countdown_RunningInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Countdown_RunningInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_countdown_running(inputs)
	if (locale === "es-419") return es_419_body_assessment_countdown_running(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_countdown_running(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_countdown_running(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_countdown_running(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_countdown_running(inputs)
	return en_us2_body_assessment_countdown_running(inputs)
});
export { body_assessment_countdown_running as "body-assessment.countdown_running" }